import React from "react";

const Stat_Hyp_Testing_Mean = () => {
  return (
    <div>
      <h1>Stat Hyp. Testing Mean</h1>
    </div>
  );
};

export default Stat_Hyp_Testing_Mean;
